import { render, staticRenderFns } from "./NeoBoxCheck.vue?vue&type=template&id=615194b8&scoped=true&"
import script from "./NeoBoxCheck.vue?vue&type=script&lang=js&"
export * from "./NeoBoxCheck.vue?vue&type=script&lang=js&"
import style0 from "./NeoBoxCheck.vue?vue&type=style&index=0&id=615194b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615194b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
